// Dalga 2 K10 — müşteri/denetçi notu alanı (hücre editörü + yalnız-not editörü ortak).
// Metinde "AI/üretim/danışman notu" geçmez (müşteri yüzeyi — spec 09/15b kilidi).

import { useId } from "react";
import { KPI_COPY } from "../../lib/kpi-ui";
import { cellInputStyle as inp } from "./kpi-form-styles";

export function KpiCellClientNote(props: {
  value: string;
  onChange: (v: string) => void;
  label?: string;
  placeholder?: string;
  testId?: string;
}): JSX.Element {
  const id = useId();
  const label = props.label ?? KPI_COPY.portal.noteLabel;
  return (
    <>
      <label htmlFor={id} className="text-xs" style={{ color: "var(--color-text-3)" }}>
        {label}
      </label>
      <div>
        <textarea
          id={id}
          data-testid={props.testId ?? "kpi-client-reply"}
          style={{ ...inp, minHeight: 56, resize: "vertical", width: "100%" }}
          value={props.value}
          maxLength={2000}
          onChange={(e) => props.onChange(e.target.value)}
          placeholder={props.placeholder ?? KPI_COPY.portal.noteHint}
        />
      </div>
    </>
  );
}
